export default "__VITE_ASSET__ef6857ed__"